import { createSelector } from '@reduxjs/toolkit';

const selectMasterData = (state) => state.masterData || {};

export const selectMasterItems = createSelector(
  [selectMasterData],
  (masterData) => masterData.items || []
);

export const selectMasterCustomers = createSelector(
  [selectMasterData],
  (masterData) => masterData.customers || []
);

export const selectMasterEmployees = createSelector(
  [selectMasterData],
  (masterData) => masterData.employees || []
);

export const selectMasterCategories = createSelector(
  [selectMasterData],
  (masterData) => masterData.categories || []
);

export const selectMasterDataLoading = createSelector(
  [selectMasterData],
  (masterData) => !!masterData.loading
);
